import { z } from 'zod';
import { nonEmptyTrimmed } from './primitives.js';

export const bankSchema = z.object({
  bankName: nonEmptyTrimmed('Bank / building society name', 120),
  accountName: nonEmptyTrimmed('Account name', 120),
  accountNumber: z
    .string({ required_error: 'Account number is required' })
    .trim()
    .regex(/^\d{8}$/, 'Account number must be 8 digits'),
  sortCode: z
    .string({ required_error: 'Sort code is required' })
    .trim()
    .transform((v) => v.replace(/-/g, ''))
    .pipe(z.string().regex(/^\d{6}$/, 'Sort code must be 6 digits')),
});

export type Bank = z.infer<typeof bankSchema>;
